import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import AppProvider from './providers/AppProvider';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { router } from './routes';
import './helpers/initFA'; //iconos generales de Fontawesone

// Importar analizador de logs para desarrollo y debugging
import './utils/logAnalyzer';

const container = document.getElementById('main');
const root = createRoot(container);

root.render(
  <AppProvider>
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
  </AppProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
